// SPDX-License-Identifier: MIT
// Adcoin
export const ACC = 'ACC';
// Akash-Network
export const AKT = 'AKT';
// Algorand
export const ALGO = 'ALGO';
// Anon
export const ANON = 'ANON';
// Aptos
export const APT = 'APT';
// Arbitrum
export const ARB = 'ARB';
// Argoneum
export const AGM = 'AGM';
// Artax
export const XAX = 'XAX';
// Aryacoin
export const AYA = 'AYA';
// Asiacoin
export const AC = 'AC';
// Auroracoin
export const AUR = 'AUR';
// Avalanche
export const AVAX = 'AVAX';
// Avian
export const AVN = 'AVN';
// Axe
export const AXE = 'AXE';
// Axelar
export const AXL = 'AXL';
// Band-Protocol
export const BAND = 'BAND';
// Base
export const BASE = 'BASE';
// Bata
export const BTA = 'BTA';
// Beetle Coin
export const BEET = 'BEET';
// Bela Coin
export const BELA = 'BELA';
// Binance
export const BNB = 'BNB';
// Bit Cloud
export const BTDX = 'BTDX';
// Bitcoin
export const BTC = 'BTC';
// Bitcoin Atom
export const BCA = 'BCA';
// Bitcoin-Cash
export const BCH = 'BCH';
// Bitcoin-Cash-SLP
export const SLP = 'SLP';
// Bitcoin Gold
export const BTG = 'BTG';
// Bitcoin-Green
export const BITG = 'BITG';
// Bitcoin Plus
export const XBC = 'XBC';
// Bitcoin-Private
export const BTCP = 'BTCP';
// Bitcoin SV
export const BSV = 'BSV';
// BitcoinZ
export const BTCZ = 'BTCZ';
// Bitcore
export const BTX = 'BTX';
// Bit Send
export const BSD = 'BSD';
// Blackcoin
export const BLK = 'BLK';
// Blocknode
export const BND = 'BND';
// Block Stamp
export const BST = 'BST';
// Bolivarcoin
export const BOLI = 'BOLI';
// Brit Coin
export const BRIT = 'BRIT';
// Canada eCoin
export const CDN = 'CDN';
// Cannacoin
export const CCN = 'CCN';
// Cardano
export const ADA = 'ADA';
// Celo
export const CELO = 'CELO';
// Chihuahua
export const HUA = 'HUA';
// Clams
export const CLAM = 'CLAM';
// Club Coin
export const CLUB = 'CLUB';
// Compcoin
export const CMP = 'CMP';
// Cosmos
export const ATOM = 'ATOM';
// CPU Chain
export const CPU = 'CPU';
// Crane Pay
export const CRP = 'CRP';
// Crave
export const CRAVE = 'CRAVE';
// Dash
export const DASH = 'DASH';
// DeepOnion
export const ONION = 'ONION';
// Defcoin
export const DFC = 'DFC';
// Denarius
export const DNR = 'DNR';
// Diamond
export const DMD = 'DMD';
// Digi Byte
export const DGB = 'DGB';
// Digitalcoin
export const DGC = 'DGC';
// Divi
export const DIVI = 'DIVI';
// Dogecoin
export const DOGE = 'DOGE';
// dYdX
export const DYDX = 'DYDX';
// eCash
export const XEC = 'XEC';
// E-coin
export const ECN = 'ECN';
// EDR Coin
export const EDRC = 'EDRC';
// e-Gulden
export const EFL = 'EFL';
// Einsteinium
export const EMC2 = 'EMC2';
// Elastos
export const ELA = 'ELA';
// Energi
export const NRG = 'NRG';
// EOS
export const EOS = 'EOS';
// Ergo
export const ERG = 'ERG';
// Ethereum
export const ETH = 'ETH';
// Europe Coin
export const ERC = 'ERC';
// Evrmore
export const EVR = 'EVR';
// Exclusive Coin
export const EXCL = 'EXCL';
// Fantom
export const FTM = 'FTM';
// Feathercoin
export const FTC = 'FTC';
// Fetch.ai
export const FET = 'FET';
// Filecoin
export const FIL = 'FIL';
// Firo
export const FIRO = 'FIRO';
// Firstcoin
export const FRST = 'FRST';
// FIX
export const FIX = 'FIX';
// Flashcoin
export const FLASH = 'FLASH';
// Flux
export const FLUX = 'FLUX';
// Foxdcoin
export const FOXD = 'FOXD';
// Fuji Coin
export const FJC = 'FJC';
// Game Credits
export const GAME = 'GAME';
// GCR Coin
export const GCR = 'GCR';
// Go Byte
export const GBX = 'GBX';
// Gridcoin
export const GRC = 'GRC';
// Groestl Coin
export const GRS = 'GRS';
// Gulden
export const NLG = 'NLG';
// Harmony
export const ONE = 'ONE';
// Helleniccoin
export const HNC = 'HNC';
// Hempcoin
export const THC = 'THC';
// Horizen
export const ZEN = 'ZEN';
// Huobi Token
export const HT = 'HT';
// Hush
export const HUSH = 'HUSH';
// ICON
export const ICX = 'ICX';
// Injective
export const INJ = 'INJ';
// InsaneCoin
export const INSN = 'INSN';
// Internet Of People
export const IOP = 'IOP';
// IRISnet
export const IRIS = 'IRIS';
// IX Coin
export const IXC = 'IXC';
// Jumbucks
export const JBS = 'JBS';
// Kava
export const KAVA = 'KAVA';
// Kobocoin
export const KOBO = 'KOBO';
// Komodo
export const KMD = 'KMD';
// Landcoin
export const LDCN = 'LDCN';
// LBRY Credits
export const LBC = 'LBC';
// Linx
export const LINX = 'LINX';
// Litecoin
export const LTC = 'LTC';
// Litecoin Cash
export const LCC = 'LCC';
// LitecoinZ
export const LTZ = 'LTZ';
// Lkrcoin
export const LKR = 'LKR';
// Lynx
export const LYNX = 'LYNX';
// Mazacoin
export const MZC = 'MZC';
// Megacoin
export const MEC = 'MEC';
// Metis
export const METIS = 'METIS';
// Minexcoin
export const MNX = 'MNX';
// Monacoin
export const MONA = 'MONA';
// Monero
export const XMR = 'XMR';
// Monk
export const MONK = 'MONK';
// MultiversX
export const EGLD = 'EGLD';
// Myriadcoin
export const XMY = 'XMY';
// Namecoin
export const NMC = 'NMC';
// Nano
export const XNO = 'XNO';
// Navcoin
export const NAV = 'NAV';
// Near
export const NEAR = 'NEAR';
// Neblio
export const NEBL = 'NEBL';
// Neo
export const NEO = 'NEO';
// Neoscoin
export const NEOS = 'NEOS';
// Neurocoin
export const NRO = 'NRO';
// Neutron
export const NTRN = 'NTRN';
// New York Coin
export const NYC = 'NYC';
// Nine-Chronicles
export const NCG = 'NCG';
// NIX
export const NIX = 'NIX';
// Novacoin
export const NVC = 'NVC';
// NuBits
export const NBT = 'NBT';
// NuShares
export const NSR = 'NSR';
// OK Cash
export const OK = 'OK';
// OKT-Chain
export const OKT = 'OKT';
// Omni
export const OMNI = 'OMNI';
// Onix
export const ONX = 'ONX';
// Ontology
export const ONT = 'ONT';
// Optimism
export const OP = 'OP';
// Osmosis
export const OSMO = 'OSMO';
// Particl
export const PART = 'PART';
// Peercoin
export const PPC = 'PPC';
// Pesobit
export const PSB = 'PSB';
// Phore
export const PHR = 'PHR';
// Pi-Network
export const PI = 'PI';
// Pinkcoin
export const PINK = 'PINK';
// Pivx
export const PIVX = 'PIVX';
// Polygon
export const MATIC = 'MATIC';
// PoSW Coin
export const POSW = 'POSW';
// Potcoin
export const POT = 'POT';
// Project Coin
export const PRJ = 'PRJ';
// Putincoin
export const PUT = 'PUT';
// Qtum
export const QTUM = 'QTUM';
// Rapids
export const RPD = 'RPD';
// Ravencoin
export const RVN = 'RVN';
// Reddcoin
export const RDD = 'RDD';
// Ripple
export const XRP = 'XRP';
// Ritocoin
export const RITO = 'RITO';
// RSK
export const RBTC = 'RBTC';
// Rubycoin
export const RBY = 'RBY';
// Safecoin
export const SAFE = 'SAFE';
// Saluscoin
export const SLS = 'SLS';
// Scribe
export const SCRIBE = 'SCRIBE';
// Secret
export const SCRT = 'SCRT';
// Shadow Cash
export const SDC = 'SDC';
// Shentu
export const CTK = 'CTK';
// Slimcoin
export const SLM = 'SLM';
// Smileycoin
export const SMLY = 'SMLY';
// Solana
export const SOL = 'SOL';
// Solarcoin
export const SLR = 'SLR';
// Stafi
export const FIS = 'FIS';
// Stash
export const STASH = 'STASH';
// Stellar
export const XLM = 'XLM';
// Stratis
export const STRAT = 'STRAT';
// Sugarchain
export const SUGAR = 'SUGAR';
// Sui
export const SUI = 'SUI';
// Syscoin
export const SYS = 'SYS';
// Terra
export const LUNA = 'LUNA';
// Tezos
export const XTZ = 'XTZ';
// Theta
export const THETA = 'THETA';
// Thought AI
export const THT = 'THT';
// TOA Coin
export const TOA = 'TOA';
// Tron
export const TRX = 'TRX';
// TWINS
export const TWINS = 'TWINS';
// Ultimate Secure Cash
export const USC = 'USC';
// Unobtanium
export const UNO = 'UNO';
// Vcash
export const VC = 'VC';
// VeChain
export const VET = 'VET';
// Verge
export const XVG = 'XVG';
// Vertcoin
export const VTC = 'VTC';
// Viacoin
export const VIA = 'VIA';
// Vivo
export const VIVO = 'VIVO';
// Voxels
export const VOX = 'VOX';
// Virtual Cash
export const VASH = 'VASH';
// Wagerr
export const WGR = 'WGR';
// Whitecoin
export const XWC = 'XWC';
// Wincoin
export const WC = 'WC';
// XinFin
export const XDC = 'XDC';
// XUEZ
export const XUEZ = 'XUEZ';
// Ycash
export const YEC = 'YEC';
// Zcash
export const ZEC = 'ZEC';
// ZClassic
export const ZCL = 'ZCL';
// Zetacoin
export const ZET = 'ZET';
// Zilliqa
export const ZIL = 'ZIL';
// ZooBC
export const ZBC = 'ZBC';
//# sourceMappingURL=symbols.js.map